/**
 * Created by zzy on 2019/8/6.
 */
import AnnularPie from './AnnularPie.vue'
export default AnnularPie



// WEBPACK FOOTER //
// ./src/components/echarts/annularPie/index.js